<!-- 城市详情 -->
<template>
  <div class="city">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.return_data"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="elite_odd_name"
          label="零工姓名"
        ></el-table-column>
        <el-table-column
          prop="id_card_number"
          label="身份证号码"
        ></el-table-column>
        <el-table-column prop="auth_time" label="认证时间"> </el-table-column>
        <el-table-column
          prop="location_place"
          label="所在地区"
        ></el-table-column>
        <el-table-column
          prop="location_detail"
          label="详细地区"
        ></el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="pagesize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
import axios from "axios";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      pagesize: 15,
      page: 0,
      total: 0,
    };
  },
  created() {
    this.list();
    // axios.get("../static/json/zhiWei.json").then((res) => {
    //   console.log(res);
    //   this.zhi_wei = res;
    // });
  },

  methods: {
    time(timestamp) {
      function add0(m) {
        return m < 10 ? "0" + m : m;
      }
      //时间戳转化成时间格式
      //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
      var time = new Date(timestamp);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var hours = time.getHours();
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();
      return year + "-" + add0(month) + "-" + add0(date);
    },
    handleCurrentChange(val) {
      this.page = val - 1;
      this.list();
    },
    goPage() {
      this.$router.go(-1);
    },
    list() {
      let obj = {
        search: this.$route.query.search,
        city_id: this.$route.query.city_id,
        page: this.page,
      };
      require("post", "/hrswork_index_data/v1/odd_auth_detail/", obj).then(
        (res) => {
          if (res.code == 0) {
            console.log(res);
            this.tableData = res.data;
            this.loading = false;
            this.total = res.data.search_count;
          } else {
          }
        }
      );
    },
  },
};
</script>
<style scoped>
/* //@import url(); 引入公共css类 */
.city {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;

  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
.page {
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/index/odd_city.vue